import React from 'react';
import {ReactComponent as Logo} from '../../../Assets/Logo/logowhite.svg';
import './Logo.scss';
const WhiteLogo=()=>{
    return(
        <div className="logonav">
            <Logo />
            
        </div>
    )
};
export default WhiteLogo ;